module.exports = __webpack_public_path__ + "img/onlineCustomer.4288f2e8.svg";